import React from 'react';
import { FlexScroller } from '../../../ui/Scrollers';
import { useResolve } from '../../Container';
import { AccountModel } from '../AccountModel';
import { AccountBlock } from './AccountBlock';
import { AdvertBlock } from './AdvertBlock';
import { HelpVideoBlock } from './HelpVideoBlock';
import { Navigation } from './Navigation';
import { NoWorkspaceBlock } from './NoWorkspaceBlock';
import { UserBlock } from './UserBlock';
import { UserMenuBlock } from './UserMenuBlock';
import { WorkspaceMenuBlock } from './WorkspaceMenuBlock';
import { WorkspaceSelectorBlock } from './WorkspaceSelectorBlock';

export const NewNavigationView = () => {

    const account = useResolve(AccountModel);
    const hasAnyTeams = account.workspaces.some(x => x.type === 'team' || x.type === 'user');
    const hasTeam = account.workspaces.find(x => x.type === 'team' || x.type === 'user');

    return <Navigation>
        <Navigation.Section>
            <AccountBlock />
            <UserMenuBlock />
        </Navigation.Section>
        <Navigation.Divide />
        <Navigation.Section grow>
            <NoWorkspaceBlock />
            {hasAnyTeams && <WorkspaceSelectorBlock />}
            {hasTeam &&
                <FlexScroller>
                    <WorkspaceMenuBlock />
                </FlexScroller>
            }
        </Navigation.Section>
        <Navigation.Advert>
            <HelpVideoBlock />
        </Navigation.Advert>
        <Navigation.Advert>
            <AdvertBlock />
        </Navigation.Advert>
        <Navigation.Divide />
        <Navigation.Section end>
            <UserBlock />
        </Navigation.Section>
    </Navigation>;
};
